import Vue from 'vue';

// axios
import axios from 'axios';

let baseURL;

const prodURL =
  window.location.origin.includes('indsiders.com') &&
  !window.location.origin.includes('dev') &&
  !window.location.origin.includes('homolog');
const homologURL = window.location.origin.includes('homolog');

if (prodURL) {
  baseURL = 'https://api-php-v2.indsiders.com';
} else if (homologURL) {
  baseURL = 'https://app-indsiders-myind-api-php-homolog.azurewebsites.net';
} else {
  baseURL = 'https://app-indsiders-myind-api-php-dev.azurewebsites.net';
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

if (prodURL) {
  baseURL = 'https://api-v2.indsiders.com';
} else if (homologURL) {
  baseURL = 'https://app-indsiders-myind-api-homolog.azurewebsites.net';
} else {
  baseURL = 'https://app-indsiders-myind-api-dev.azurewebsites.net';
}

const evoAxiosIns = axios.create({
  baseURL
});

evoAxiosIns.interceptors.request.use(
  (config) => {
    const userInfo = Vue.prototype.$cookies?.get('userInfo');
    const temporaryToken = userInfo?.temporaryToken || '';

    config.headers.Authorization = `Bearer ${temporaryToken}`;
    config.headers.token = temporaryToken;

    return config;
  },
  (error) => Promise.reject(error)
);

Vue.prototype.$http = axiosIns;
Vue.prototype.$http2 = evoAxiosIns;

export default axiosIns;
